module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1164.f7a22e72.jpg";